import React from 'react'

import { GridItem, Paper } from '../../common/Form'
import DataSet from '../../common/DataSet'
import { ExternalLink } from '../../common/Link'
import { KubernetesNode } from 'common/api/v1/types'
export interface MetaProps {
  node: KubernetesNode
}

const Meta: React.FunctionComponent<MetaProps> = ({ node }) => {
  const region = { external: false }

  const metrics = !region.external
    ? {
        Metrics: (
          <ExternalLink
            underline="always"
            href={`/grafana/d/000000127/system-resource-usage?orgId=1&var-DS_PROMETHEUS=Prometheus&var-job=node-exporter&var-name=${node.name}&from=now-15m&to=now&refresh=1m`}
          >
            Resource Usage
          </ExternalLink>
        ),
      }
    : {}
  const meta = {
    Name: node.name,
    Region: node.region.name,
    Status: node.status,
    'Internal IP': node.internalIP,
    'External IP': node.externalIP,
    'Kubelet version': node.kubeletVersion,
    ...metrics,
  }

  return (
    <Paper title="Metadata" collapsible actionsPane={[]}>
      <GridItem lg={12} xl={12}>
        <DataSet values={meta} />
      </GridItem>
      {/* {linkIsShown && <Divider style={{ width: '100%' }} />} */}
    </Paper>
  )
}

export default Meta
